import React from 'react';
import { MainTitle } from '.';
import { Table } from 'antd';
import routeConstant from '../../constants/route.constants';
import FullPageLink from './FullPageLink';

const TermOfUseModal = () => {
  const dataSource = [
    {
      key: '1',
      name: 'Số lượng biểu đồ',
      free: 1,
      plus: 10,
    },
    {
      key: '2',
      name: 'Số lượng thành viên trên 1 biểu đồ',
      free: 100,
      plus: 10000,
    },
    {
      key: '3',
      name: 'Tổng số lượng ảnh tải lên',
      free: 10,
      plus: 500,
    },
    {
      key: '4',
      name: 'Giới hạn dung lượng mỗi ảnh',
      free: '3 MB',
      plus: '10 MB',
    },
    {
      key: '5',
      name: 'Tổng dung lượng ảnh tải lên',
      free: '30 MB',
      plus: '5 GB',
    },
    {
      key: '6',
      name: 'Hạn sử dụng mỗi ảnh',
      free: '7 ngày',
      plus: 'Vĩnh viễn',
    },
  ];

  const columns = [
    {
      title: 'Thông số',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Miễn phí',
      dataIndex: 'free',
      key: 'free',
    },
    {
      title: 'Nâng cao',
      dataIndex: 'plus',
      key: 'plus',
    },
  ];

  return (
    <div className="modal-content-wrapper">
      <MainTitle>Điều khoản sử dụng</MainTitle>
      <FullPageLink url={routeConstant.TERM_OF_USE} />

      <div className="main-content">
        <div id="main_0_DivCode">
          <div>
            <ol>
              <li>
                <h4>Miễn phí</h4>
                <p>Hệ thống miễn phí với mọi tính năng.</p>
                
                <p>
                  Do hệ thống tốn chi phí để vận hành và lưu trữ ảnh nên chức năng miễn phí có một
                  số giới hạn nhất định, mặc dù vẫn đáp ứng đủ nhu cầu sử dụng cơ bản.
                </p>
                <p>
                  Cụ thể, mỗi ảnh chỉ có hiệu lực sau khi tải lên 7 ngày. Sau đó hệ thống sẽ tự động
                  xóa để tiết kiệm dung lượng.
                </p>
                <p>Sau đây là các thông số giới hạn mà bạn có thể sử dụng.</p>
                <Table
                  id="usageLimit"
                  size="small"
                  style={{ paddingBottom: '20px' }}
                  dataSource={dataSource}
                  columns={columns}
                  pagination={false}
                />
              </li>

              <li>
                <h4>Nâng cao (đang hoàn thiện)</h4>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermOfUseModal;
